import { isNil } from '@flowio/is';
import { RequestPaymentParameters } from '../../types';
import cardManagedForm from './cardManagedForm';
import cardRawForm from './cardRawForm';

export default function handleCardPaymentRequest(
  requestOptions: RequestPaymentParameters,
): Promise<io.flow.v0.models.PaymentMethodDataAuthorizeCard> {
  const pm = requestOptions.data.paymentMethod;
  if (isNil(pm) || pm.id !== 'card') {
    throw new Error('handleCardPaymentRequest: called with null or non-card payment method');
  }
  return Promise.resolve().then(() => {
    switch (pm.type) {
      case 'managed_form':
        return cardManagedForm(requestOptions);
        break;
      case 'raw_form':
        return cardRawForm(requestOptions);
        break;
      default:
        throw new Error('handleCardPaymentRequest: unknown card request');
    }
  });
}
